import {useTranslation} from 'react-i18next'
import {createUseStyles} from 'react-jss'
import {UpcomingPayroll} from '../../../../../redux/types'
import {PayrollHeader, StatusMessage, UploadedFilesContainer, PayrollActions} from '..'
import Button from "../../../../Button"
import { useValidationErrorsModal } from '../../hooks'
import PayrollFileErrorsModal from "../../../PayrollFileErrorsModal"

interface ValidationErrorContentProps {
  upcomingPayroll: UpcomingPayroll
}

const ValidationErrorContent = ({
  upcomingPayroll
}: ValidationErrorContentProps) => {
  const {t} = useTranslation(['common', 'payrolls'])
  const styles = useStyles()

  const validationErrorsModal = useValidationErrorsModal()

  return (
    <>
      <PayrollHeader
        labelText={upcomingPayroll.offCycle ? t('offCyclePayment', {ns: 'payrolls'}) : t('upcomingPayday', {ns: 'payrolls'})}
        paymentDate={upcomingPayroll.paymentDate}
      />
      <UploadedFilesContainer
        errorsExist={true}
        upcomingPayroll={upcomingPayroll}
      />
      <StatusMessage
        message={t('issuesFoundTitle', {ns: 'payrolls'})}
      />
      <div className={styles.modalButtonContainer}>
        <Button
          onClick={validationErrorsModal.show}
          title={t('reviewIssuesTemplate', {ns: 'payrolls', issueCount: upcomingPayroll.validationErrors.length})}
          variant="positive"
        />
      </div>
      <PayrollActions
        upcomingPayroll={upcomingPayroll}
      />

      <PayrollFileErrorsModal
        visible={validationErrorsModal.visible}
        errors={upcomingPayroll.validationErrors ?? []}
        onCloseClick={validationErrorsModal.hide}
      />
    </>
  )
}

const useStyles = createUseStyles({
  modalButtonContainer: {
    display: 'flex',
    flex: 1,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10,
    marginBottom: 20
  }
})

export default ValidationErrorContent
